<div class="p-3">
  <p class="is-bold is-size-5 color-darkblue has-text-centered mb-4">
    {{ data.isConnectOrigin ? 'Zusätzliche Kosten bei mehreren Grundbuchblättern' : 'Weitere Informationen erforderlich' }}
  </p>

  <ng-container *ngIf="!data.isConnectOrigin">
    <p class="is-bold">Für die Beschaffung des Grundbuchauzuges sind weitere Informationen erforderlich.</p>

    <p class="is-bold is-size-6 mt-4">Grundbuchblatt-Nr.</p>

    <app-folio-number [property]="selectedProperty" [displayAdditionalCostInformation]="true"></app-folio-number>

    <p class="is-bold is-size-6 mt-4">Eigentümerdaten</p>

    <p class="my-3">
      <span class="has-text-info"><fa-icon [icon]="faInfoCircle"></fa-icon></span>
      Fehlerhafe Angaben können zu erheblichen Verzögerungen bei der Beschaffung der Auskunft führen.
    </p>
    <app-object-owner [property]="selectedProperty"></app-object-owner>
  </ng-container>

  <ng-container *ngIf="data.isConnectOrigin">
    <div class="columns mb-0">
      <div class="column pb-0">
        <p>Für den Fall, dass die Liegenschaft mehrere Grundbuchblätter umfasst, kostet jeder zusätzliche
          Grundbuchauszug 50% des Dokumentenpreises.</p>
        <p class="mt-5">
          <label class="checkbox">
            <input type="checkbox" #checkboxRef>
            Diesen Hinweis in Zukunft nicht mehr anzeigen
          </label>
        </p>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="ProductUtils.shouldOpenProductValueDialog([grundeProduct]) else defaultButtons">
    <hr>
    <app-product-value-form [products]="[grundeProduct]" [property]="selectedProperty" [hasPadding]="false"
                            [displayCancelButton]="true" [cancelButtonText]="'Abbrechen'" [confirmButtonText]="'Weiter'"
                            (confirmModalEvent)="addGrundeDocument()"
                            [displayHeader]="false" [displayDocName]="false"
                            (cancelModalEvent)="closeModal()"></app-product-value-form>
  </ng-container>

  <ng-template #defaultButtons>
    <div class="columns is-justify-content-end mt-4">
      <div class="column is-one-third">
        <a (click)="closeModal()" class="no-border back-button is-size-6 has-round-border has-text-centered">
          <div class="columns full-width">
            <div class="column is-12 is-bold relative is-flex is-justify-content-center is-align-items-center">
              <img alt="Arrow Left" src="assets/images/button/left_btn.svg" class="absolute left-0">
              <p>Abbrechen</p>
            </div>
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a (click)="addGrundeDocument()" class="no-border buy-button is-size-6 has-round-border has-text-centered">
          <div class="columns full-width">
            <div class="column is-12 is-bold relative">
              <p>Weiter</p>
              <img alt="Arrow Right" src="assets/images/button/right_btn.svg" class="absolute has-text-right">
            </div>
          </div>
        </a>
      </div>

    </div>
  </ng-template>
</div>
